import {
  IsNotEmpty,
  IsString,
  IsOptional,
  IsArray,
  IsObject
} from 'class-validator';
import { IBaseResponse } from './base-response.dto';

export interface ISegment {
  _id?: string;
  label: string;
  description: string;
  organization: string;
  createdAt?: string;
  updatedAt?: string;
  query: string;
}

/* -------------------------------------------------------------------------- */
/*                               Create new Segment                              */
/* -------------------------------------------------------------------------- */

export class CreateSegmentDto {
  @IsNotEmpty()
  @IsString()
  label: string;
  
  @IsString()
  @IsOptional()
  description?: string;
  
  @IsString()
  @IsOptional()
  organization?: string;
  
  @IsString()
  @IsNotEmpty()
  query: any;
}

export interface CreateSegmentResponse extends IBaseResponse {
  segment: ISegment;
}

/* -------------------------------------------------------------------------- */
/*                                   Update Segment                              */
/* -------------------------------------------------------------------------- */

export class UpdateSegmentDto {
  @IsOptional()
  @IsString()
  title: string;
  @IsString()
  @IsOptional()
  description?: string;
  @IsString()
  @IsNotEmpty()
  query: any;
}

export interface UpdateSegmentResponse extends IBaseResponse {
  id: string;
}

/* -------------------------------------------------------------------------- */
/*                                  Get Segment                                 */
/* -------------------------------------------------------------------------- */
export class GetSegmentDto {
}

export type GetSegmentResponse = ISegment[];
